module.exports = __webpack_public_path__ + "img/mars-stroke-h.8ee78a06.svg";